import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import VideoBtn from './VideoBtnMobile';
import EndOfScreen from '../../objects/producerNotes/EndOfScreen';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import ProducerNotes from '../../objects/producerNotes/ProducerNotes';
import NotReadyYet from '../../objects/producerNotes/NotReadyYet';
import ProtoType from '../../objects/prototypeObjects/PrototypeVideoMobileScreen';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import {getAssetComponentByType} from '../../../helpers/componentHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as localStorage from '../../../localStorage/localStorage';
import _ from 'lodash';
import * as animationHelper from "../../../helpers/animationHelper";

class VideoMobileScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screen: this.props.screen,
            userData: this.props.userData,
            showContentOutlineInPreview: props.showContentOutlineInPreview,
            is_resource_screen: appHelper.isDefined(this.props.screen.is_resource_screen) && this.props.screen.is_resource_screen,
            locale: {},
            status: objectConstants.STATUS_NOT_STARTED,
            multiPath: appHelper.isDefined(this.props.screen.multi_path) ? this.props.screen.multi_path : {enabled: false},
            allowReviewMode: true,
            reviewMode: false,
            propsUpdated: false,
            renderedObject: {},
            completeObjects: [],
            enabledObjects: [],
            updateCharacter: false,
            screenCharacter: {},
            assets: {
                background: {
                    src: "",
                    type: "",
                    type_id: ""
                },
                screenAsset: {
                    src: "",
                    pose: "",
                    position: ""
                }
            },
            callbacks: {
                updateCharacterExpression: null,
                onObjectComplete: null,
            },
            callbacksSet: false,
            currentObjectIndex: 0,
            showProgression: false,
            allowGoToScreen: false,
            goToScreenId: 0,
            terminateScreen: false,
            terminateBite: false,
            producerNotes: appHelper.getScreenNotes(this.props.parentScreen, this.props.screen, this.props.showContentOutlineInPreview, props.contentData.experience.is_preview),
            screenIsReady: this.props.screen.objects.length > 0, //&& (appHelper.canSeeContent(this.props.screen) || appHelper.isDefined(this.props.parentScreen)),
            scrollToBtn: false,
            continue_label: appHelper.getLocaleString("continue_label"),
            nextObject: {},
            setNextButton: false,
            showEndOfScreenMessage: false,
        };
        this.getLocale = this.getLocale.bind(this);
        this.setObjectEnabled = this.setObjectEnabled.bind(this);
        this.setObjectComplete = this.setObjectComplete.bind(this);
        this.getInitialObject = this.getInitialObject.bind(this);
        this.getObject = _.debounce(this.getObject.bind(this), 300);
        this.setNextObject = this.setNextObject.bind(this);
        this.getScreenId = this.getScreenId.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.isReviewMode = this.isReviewMode.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.onObjectComplete = this.onObjectComplete.bind(this);
        this.updateScreenResults = _.debounce(this.updateScreenResults.bind(this), 300);
        this.setScreenAccessed = _.debounce(this.setScreenAccessed.bind(this), 300);
        this.showProgressionButton = this.showProgressionButton.bind(this);
        this.navigateToNextScreen = this.navigateToNextScreen.bind(this);
        this.scrollTo = this.scrollTo.bind(this);
        this.onScrollComplete = this.onScrollComplete.bind(this);
        this.onContinueBtnReveled = this.onContinueBtnReveled.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.checkScreenStatus = this.checkScreenStatus.bind(this);
        this.goToScreen = this.goToScreen.bind(this);
        //new
        this.getCharacterName = this.getCharacterName.bind(this);
        this.handleObjectProgression = this.handleObjectProgression.bind(this);
        this.hasNextObject = this.hasNextObject.bind(this);
        this.getLayoutClass = this.getLayoutClass.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getSubScreenParent = this.getSubScreenParent.bind(this);
        this.checkIsResourceScreen = this.checkIsResourceScreen.bind(this);
        this.updateResourceObjectResult = this.updateResourceObjectResult.bind(this);
        this.updateResourceScreenResult = this.updateResourceScreenResult.bind(this);
        this.setScreenNotReadyYet = this.setScreenNotReadyYet.bind(this);
        this.setScreenNotReadyYet = this.setScreenNotReadyYet.bind(this);
        this.scrollToVideo = this.scrollToVideo.bind(this);
        this.getNextlessonLocation = this.getNextlessonLocation.bind(this);
        this.handleNextButton = this.handleNextButton.bind(this);
        this.getNextScreenObject = this.getNextScreenObject.bind(this);
        this.goToMenu = this.goToMenu.bind(this);

        this.feed = React.createRef();
    }

    componentDidMount() {
        this.setScreenAccessed();
        this.props.biteCallbacks.showHeader(true);
        this.checkScreenStatus();
        this.setCallbacks();
        this.getLocale();
        if (this.state.screenIsReady) {
            //this.setObjectEnabled(this.state.screen.objects[this.state.currentObjectIndex]);
            this.getInitialObject();
        } else {
            this.setScreenNotReadyYet();
        }
        this.getAssets();

    }

    componentWillReceiveProps(nextProps) {
        let screenUserData = {};
        if (this.state.is_resource_screen) {
            screenUserData = userDataHelper.getResourceScreenUserData(nextProps.userData, this.state.screen.screen_id);
        } else if (this.props.parentScreen) {
            screenUserData = userDataHelper.getSubScreenUserData(nextProps.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);

        } else {
            screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
        }
        this.setState({userData: Object.assign({}, nextProps.userData)});

        if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
                setNextButton: true,
            });
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                continue_label: appHelper.getLocaleString("continue_label")
            });

            if (!appHelper.isDefined(this.props.parentScreen)) {
                this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
            }
        }

        if(this.state.showContentOutlineInPreview !== nextProps.showContentOutlineInPreview){
            this.setState({
                showContentOutlineInPreview: nextProps.showContentOutlineInPreview,
                producerNotes: appHelper.getScreenNotes(this.props.parentScreen, this.state.screen, nextProps.showContentOutlineInPreview, this.props.contentData.experience.is_preview),
            });
        }
    }

    componentDidUpdate() {

        if (this.state.updateCharacter) {

            this.transitionCharacterExpressions();
        }

        if(appHelper.isDefined(this.state.nextObject.asset_id)){
            this.setNextObject();
        }

        if(this.state.setNextButton){
            this.handleNextButton();
        }
    }

    setScreenAccessed(){
        this.props.actions.setScreenAccessed(this.state.screen, this.props.parentScreen);
    }

    setScreenNotReadyYet() {
        let completionData = {
            screen_status: objectConstants.STATUS_COMPLETE,
            setNextButton: true,
            sub_screen_complete: appHelper.isDefined(this.props.parentScreen) ? true : undefined
        };

        //this.showProgressionButton();

        this.updateScreenResults(completionData);
    }

    checkScreenStatus() {
        let screenUserData = {};
        if (this.state.is_resource_screen) {
            screenUserData = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.screen.screen_id);
        } else if (this.props.parentScreen) {
            screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);

        } else {
            screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
        }

        if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
                setNextButton: true,
            });
        }
    }

    setCallbacks() {
        //console.log(`reviewMode: ${this.state.reviewMode} - line 125`);
        this.setState({
            callbacks: Object.assign({}, this.state.biteCallbacks, {
                updateCharacterExpression: this.updateCharacterExpression,
                onObjectComplete: this.onObjectComplete,
                getScreenId: this.getScreenId,
                getBiteId: this.getBiteId,
                storeUserResponse: this.storeUserResponse,
                scrollTo: this.scrollTo,
                scrollToVideo: this.scrollToVideo,
                isReviewMode: this.isReviewMode,
                getCharacterName: this.getCharacterName,
                hasNextObject: this.hasNextObject,
                navigateToNextScreen: this.navigateToNextScreen,
                getScreenStatus: this.getScreenStatus,
                getSubScreenParent: this.getSubScreenParent,
                checkIsResourceScreen: this.checkIsResourceScreen,
                goToScreen: this.goToScreen,
                getNextScreenObject: this.getNextScreenObject,
                getObject: this.getObject,
            }),
            callbacksSet: true
        });
    }

    getSubScreenParent() {
        return appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen : undefined;
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.screen);
        this.setState({locale: Object.assign({}, locale)});
        //if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
        if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
            this.props.actions.setScreenTitle(locale.title);
        }
    }

    getScreenId() {
        return this.state.screen.screen_id;
    }

    getBiteId() {

        return this.props.biteCallbacks.getBiteId();
    }

    isReviewMode() {
        return this.state.reviewMode;
    }

    getCharacterName() {
        return this.state.locale.character_name;
    }

    getScreenStatus() {
        return this.state.status;
    }

    checkIsResourceScreen() {
        return this.state.is_resource_screen;
    }

    setObjectEnabled(object) {
        let objectIndex = appHelper.getArrayObjectIndexByKey(this.state.enabledObjects, "asset_id", object.asset_id);
        if (objectIndex === -1) {
            this.setState({enabledObjects: dataHelper.immutablePush(this.state.enabledObjects, object)});
        }
    }

    setObjectComplete(object) {
        let objectIndex = appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "asset_id", object.asset_id);
        if (objectIndex === -1) {
            this.setState({completeObjects: dataHelper.immutablePush(this.state.completeObjects, object)});
        }
    }

    getInitialObject(){
        let enabledObjects = [];
        let completeObjects = [];
       for(let i = 0; i < this.state.screen.objects.length; i++){
           let object = this.state.screen.objects[i];
           let objectUserData = {};
           let subScreenParent = this.getSubScreenParent();
           let screen_id = this.state.screen.screen_id;
           if (appHelper.isDefined(subScreenParent)) {
               objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, object.asset_id);
           } else if (this.state.isResourceObject) {
               objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, object.asset_id);
           } else {
               objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, object.asset_id);
           }

           if(i === 0){
               enabledObjects = dataHelper.immutablePush(enabledObjects, object);
               if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
                   completeObjects = dataHelper.immutablePush(completeObjects, object);
               }else{
                   this.getObject(object);
               }
           }else {

               if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
                   enabledObjects = dataHelper.immutablePush(enabledObjects, object);
                   completeObjects = dataHelper.immutablePush(completeObjects, object);
               } else {
                   let previousObj = this.state.screen.objects[i - 1];
                   let preObjectUserData = {};

                   if (appHelper.isDefined(subScreenParent)) {
                       preObjectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, previousObj.asset_id);
                   } else if (this.state.isResourceObject) {
                       preObjectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, previousObj.asset_id);
                   } else {
                       preObjectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, previousObj.asset_id);
                   }

                   if(preObjectUserData.status === objectConstants.STATUS_COMPLETE){
                       enabledObjects = dataHelper.immutablePush(enabledObjects, object);
                       this.getObject(object);
                   }
               }
           }
       }

       if(completeObjects.length === this.state.screen.objects.length){
           this.getObject(this.state.screen.objects[0]);
           this.showProgressionButton();
       }

       this.setState({
           enabledObjects: Object.assign([],enabledObjects),
           completeObjects: Object.assign([],completeObjects)
       });
    }

    getObject(object) {
        this.setState({
            renderedObject: Object.assign({}, {}),
            nextObject:object,
            //autoPlay: appHelper.getArrayObjectIndexByKey(this.state.screen.objects,"asset_id",object.asset_id) > 0
        });
    }

    setNextObject() {
        this.setState({nextObject: Object.assign({}, {})});
        let objectLocale = appHelper.getLocalData(this.state.nextObject);
        let objectType = Object.assign({}, getAssetComponentByType(objectLocale.asset_sub_type_code),
            {
                data: this.state.nextObject
            }
        );

        this.setState({renderedObject: Object.assign({}, objectType)});
    }

    getNextScreenObject(object) {
        let objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", object.asset_id);
        return this.state.screen.objects[objectIndex + 1];
    }

    getAssets() {
        let backgroundAsset = Object.assign(this.state.assets.background);


        if (appHelper.isDefined(this.state.screen.assets.background)) {
            backgroundAsset = appHelper.getBackgroundAsset(this.state.screen.assets.background);
        }

        this.setState({
            assets: Object.assign({}, this.state.assets, {
                background: backgroundAsset

            })
        });

    }


    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    goToMenu(){
        this.context.router.push('menu');
    }


    getNextlessonLocation(){
        let next_lesson_location = 0;

        if (appHelper.isDefined(this.props.parentScreen)) {

            let hasNextSubScreen = this.props.biteCallbacks.hasNextSubScreen(this.state.screen);
            if (!hasNextSubScreen) {
                let nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
                if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                    if(appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)){
                        next_lesson_location = 0;
                    }else {
                        next_lesson_location = -1;
                    }
                } else {
                    if(appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)){
                        next_lesson_location = 0;
                    }else {
                        next_lesson_location = nextScreenId;
                    }
                }
            }

        } else {
            let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
            if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                next_lesson_location = -1;
            } else {
                next_lesson_location = nextScreenId;
            }
        }

        return next_lesson_location;

    }

    handleNextButton(){
        this.setState({setNextButton: false});
        let next_lesson_location = this.getNextlessonLocation();
        if(next_lesson_location !== 0) {
            this.props.actions.setNextButtonState(true, next_lesson_location);
        }
    }

    navigateToNextScreen() {
        let goToMenu = this.goToMenu;
        if (appHelper.isDefined(this.props.parentScreen)) {
            if (appHelper.isDefined(this.props.closeDialog)) {
                this.props.closeDialog();
            }
            if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId))) {
                this.goToScreen(this.state.goToScreenId);
            } else if (this.state.terminateScreen) {
                let nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
                if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                    this.context.router.push('menu');
                } else {
                    this.props.actions.setNextLessonLocation(nextScreenId);
                }
            } else if (this.state.terminateBite) {
                if (localStorage.bites.length > 1) {
                    this.context.router.push('menu');
                } else {
                    let bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
                    this.goToScreen(bite.screens[0].screen_id);
                }
            } else {
                let hasNextSubScreen = this.props.biteCallbacks.hasNextSubScreen(this.state.screen);
                if (hasNextSubScreen) {
                    this.props.biteCallbacks.goToNextSubScreen(this.state.screen);
                } else {
                    if(appHelper.isSingleScreenModule()) {
                        this.setState({showEndOfScreenMessage: true});
                    }else {
                        let nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
                        if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                            if (appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)) {
                                return false;
                            } else {
                                setTimeout(() => {
                                    goToMenu();
                                }, 500);
                            }
                        } else {
                            if (appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)) {
                                return false;
                            } else {
                                let goToScreen = this.goToScreen;
                                setTimeout(() => {
                                    goToScreen(nextScreenId);
                                }, 500);
                            }
                        }
                    }
                }
            }
        } else {
            if(appHelper.isSingleScreenModule()){
                this.setState({showEndOfScreenMessage: true});
            }else {
                if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId))) {
                    this.goToScreen(this.state.goToScreenId);
                } else if (this.state.terminateBite) {
                    if (localStorage.bites.length > 1) {
                        this.context.router.push('menu');
                    } else {
                        let bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
                        this.goToScreen(bite.screens[0].screen_id);
                    }
                } else {
                    let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
                    if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                        this.context.router.push('menu');
                    } else {
                        this.props.actions.setNextLessonLocation(this.getScreenId());
                    }
                }
            }
        }
    }

    goToScreen(goTo) {
        this.props.actions.setNewLessonLocation(goTo);

    }

    handleObjectProgression() {

    }

    onObjectComplete(completionData) {


        if (completionData.status === objectConstants.STATUS_COMPLETE) {
            let screenUserData = {};
            if (this.state.is_resource_screen) {
                screenUserData = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.screen.screen_id);
            } else if (this.props.parentScreen) {
                screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);

            } else {
                screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
            }
            if(this.state.screen.status !== objectConstants.STATUS_COMPLETE && screenUserData.status !== objectConstants.STATUS_COMPLETE){
                this.setState({scrollToBtn: true});
            }

            let currentObject = appHelper.getArrayObjectByKey(this.state.screen.objects, "asset_id", completionData.asset_id);
            this.setObjectComplete(currentObject);
        }
        if (completionData.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE || completionData.progression === objectConstants.OBJECT_PROGRESSION_AUTO) {
            let objectIndex =  appHelper.getArrayObjectIndexByKey(this.state.screen.objects,"asset_id",completionData.asset_id);
            if (objectIndex < (this.state.screen.objects.length - 1)) {
                let newIndex = objectIndex + 1;
                this.setState({currentObjectIndex: newIndex});
                this.setObjectEnabled(this.state.screen.objects[newIndex]);


                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                    //this.updateScreenResults(objectConstants.STATUS_IN_PROGRESS, asset_id, response);
                } else {
                    // this.updateScreenResults(objectConstants.STATUS_COMPLETE, asset_id, response);
                }
                completionData = Object.assign({}, completionData, {
                    screen_status: this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS : objectConstants.STATUS_COMPLETE
                });
                if (this.state.is_resource_screen) {
                    //save resource object tracking
                    this.updateResourceObjectResult(completionData);
                } else {

                    this.updateScreenResults(completionData);
                }
            } else {

                if (this.state.is_resource_screen) {
                    //Last object of resource screen we can add logic here when we need to
                    this.updateResourceObjectResult(completionData);

                } else if (appHelper.isDefined(this.props.parentScreen)) {
                    //////////////////////
                    //COMPLETE SUB SCREEN
                    /////////////////////
                    this.setState({setNextButton: true});

                    if (!completionData.navigateToNextScreen) {
                        this.showProgressionButton();
                    }

                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE,
                        sub_screen_complete: true
                    });

                    this.updateScreenResults(completionData);

                    //this.props.biteCallbacks.onSubScreenComplete(this.state.screen);

                } else {
                    this.setState({setNextButton: true});

                    if (!completionData.navigateToNextScreen) {
                        this.showProgressionButton();
                    }

                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE
                    });

                    this.updateScreenResults(completionData);
                    //////////////////////
                    //COMPLETE SCREEN
                    /////////////////////
                    //console.log(`complete screen`);
                }
            }
        } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_GO_TO) {
            if (completionData.progressionType === objectConstants.GO_TO_TYPE_OBJECT) {
                let nextObjectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", completionData.progressionGoToId);
                this.setState({currentObjectIndex: nextObjectIndex});
                this.getObject(nextObjectIndex);
                this.updateScreenResults(completionData);
            } else if (completionData.progressionType === objectConstants.GO_TO_TYPE_SCREEN) {

                this.setState({
                    allowGoToScreen: true,
                    goToScreenId: completionData.progressionGoToId,
                    setNextButton: true
                });

                if (appHelper.isDefined(this.props.parentScreen)) {

                    this.props.biteCallbacks.completeScreen();
                    //////////////////////
                    //COMPLETE SUB SCREEN
                    /////////////////////
                    if (!completionData.navigateToNextScreen) {
                        this.showProgressionButton();
                    }
                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE,
                        sub_screen_complete: true
                    });

                    this.updateScreenResults(completionData);


                } else {
                    if (!completionData.navigateToNextScreen) {
                        this.showProgressionButton();
                    }
                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE
                    });
                    this.updateScreenResults(completionData);
                    //////////////////////
                    //COMPLETE SCREEN
                    /////////////////////
                    //console.log(`complete screen`);
                }
            }

        } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_TERMINAL) {
            if (completionData.progressionType === objectConstants.TERMINAL_TYPE_SCREEN) {
                this.setState({
                    terminateScreen: true,
                    setNextButton: true
                });


                if (appHelper.isDefined(this.props.parentScreen)) {
                    //////////////////////
                    //COMPLETE SUB SCREEN
                    /////////////////////
                    this.props.biteCallbacks.completeScreen();

                    if (!completionData.navigateToNextScreen) {
                        this.showProgressionButton();
                    }
                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE,
                        sub_screen_complete: true
                    });

                    this.updateScreenResults(completionData);


                } else {
                    if (!completionData.navigateToNextScreen) {
                        this.showProgressionButton();
                    }
                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE
                    });
                    this.updateScreenResults(completionData);
                    //////////////////////
                    //COMPLETE SCREEN
                    /////////////////////
                    //console.log(`complete screen`);
                }
            } else if (completionData.progressionType === objectConstants.TERMINAL_TYPE_BITE) {
                this.setState({
                    terminateBite: true,
                    setNextButton: true
                });

                let bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
                this.props.actions.terminateBite(bite).then((userData) => {

                    if (!completionData.navigateToNextScreen) {
                        this.showProgressionButton();
                    }

                    if (appHelper.isDefined(this.props.parentScreen)) {
                        this.props.biteCallbacks.completeScreen();
                    }

                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE
                    });

                    this.updateScreenResults(completionData);

                }).catch(error => {
                });
            }
        }

    }

    updateScreenResults(completionData) {
        let params = Object.assign({}, completionData, {
            bite_id: this.getBiteId(),
            parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
            screen_id: this.getScreenId(),
            object_status: completionData.status,
            object_result: {}
        });


        this.props.actions.updateScreenResults(params).then((userData) => {
            if (appHelper.isDefined(completionData.sub_screen_complete) && completionData.sub_screen_complete) {
                this.props.biteCallbacks.onSubScreenComplete(this.state.screen);
            }
            this.props.actions.setSuspendData(userData).then((trackingData) => {

                if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
                    this.props.actions.setScreenComplete(this.state.screen, this.props.parentScreen);
                }

            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    updateResourceObjectResult(completionData) {
        let params = Object.assign({}, completionData, {
            screen_id: this.getScreenId(),
            object_status: completionData.status,

        });
        this.props.actions.updateResourceObjectResult(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                let resourceScreen = appHelper.getArrayObjectByKey(userData.resources, "screen_id", this.state.screen.screen_id);
                if (resourceScreen.status === objectConstants.STATUS_COMPLETE) {
                    if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
                        this.props.actions.setScreenComplete(this.state.screen);
                    }
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    updateResourceScreenResult(completionData) {
        let params = Object.assign({}, completionData, {
            screen_id: this.getScreenId(),
            object_status: completionData.status,
            screen_status: objectConstants.STATUS_COMPLETE
        });
        this.props.actions.updateResourceScreenResult(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
                    this.props.actions.setScreenComplete(this.state.screen);
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    showProgressionButton() {
        let nextScreenId = appHelper.getNextScreenId(this.state.screen.screen_id);
        //if (nextScreenId.length > 0) {
        this.setState({showProgression: true});
        //}
    }

    scrollTo(pos) {
        if (this.state.status !== objectConstants.STATUS_COMPLETE || this.state.scrollToBtn) {
            let feed = this.feed.current;

            if(appHelper.isEleDefined(feed)){
                let params = {
                    ele: feed,
                    duration: objectConstants.SCROLL_TO_DURATION,
                    delay: 0,
                    scrollTop: pos,
                    callback: this.onScrollComplete
                };

                animationHelper.scrollTo(params);
            }
        }
    }

    onContinueBtnReveled() {
        this.scrollToTop();
    }

    scrollToVideo(pos){
        if(appHelper.isDefined(pos)) {
            let feed = this.feed.current;

            if(appHelper.isEleDefined(feed)){
                let params = {
                    ele: feed,
                    duration: objectConstants.SCROLL_TO_DURATION,
                    delay: 0,
                    scrollTop: pos,
                    callback: this.onScrollComplete
                };

                animationHelper.scrollTo(params);
            }
        }
    }
    scrollToTop() {
        if (this.state.scrollToBtn) {
            let anchor = this.refs[`${this.state.screen.screen_id}_button`];
            let scrollToValue = anchor.offsetTop + anchor.offsetHeight;
            let scrollTo = this.scrollTo;
            this.scrollTo(scrollToValue);

        }
    }

    onScrollComplete() {

    }

    hasNextObject(object) {
        let objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", object.asset_id);
        return objectIndex < (this.state.screen.objects.length - 1);
    }

    getLayoutClass() {
        return this.state.screen.objects.length < 2 ? "single" : "";
    }

    render() {
        return (
            <div className="content-screen">
                <div className="background-container">
                    {
                        !appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen
                            ?
                            <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                            :
                            null
                    }
                </div>
                <div className="screen-container">
                    <div className="video-content-wrapper" id={`${this.state.screen.screen_id}_feed_id`} ref={this.feed}>
                        {
                            this.state.producerNotes.show_notes
                                ?
                                <div className="content-row">
                                    <ProducerNotes notes={this.state.producerNotes.notes}
                                                   screen_id={this.state.screen.screen_id}/>
                                </div>
                                :
                                null
                        }
                        {
                            !this.state.screenIsReady || !this.state.producerNotes.show_content
                                ?
                                <div className="content-row">
                                    <NotReadyYet screen_id={this.state.screen.screen_id}
                                                 onContinue={this.navigateToNextScreen}/>
                                </div>
                                :
                                null
                        }

                        {
                            this.state.screenIsReady && this.state.producerNotes.show_content
                            ?
                                <div className="content-row" ref={`${this.state.screen.screen_id}_video`}>
                                    <div className="video-object-wrapper">
                                        {
                                            this.state.screenIsReady && this.state.callbacksSet
                                                ?
                                                <div className="thumbnail-col">
                                                    {this.state.screen.objects.map(object =>
                                                        <VideoBtn key={`${object.asset_id}_btn`}
                                                                  object={object}
                                                                  activeObject={this.state.renderedObject}
                                                                  enabledObjects={this.state.enabledObjects}
                                                                  completeObjects={this.state.completeObjects}
                                                                  callbacks={this.state.callbacks}
                                                                  onClickFunc={this.getObject}/>
                                                    )}
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                                </div>
                                : null
                        }

                        {
                            !this.state.screenIsReady || !this.state.producerNotes.show_content
                                ?

                                <ProtoType />

                                :
                                null
                        }


                        {this.state.showEndOfScreenMessage ?
                            <EndOfScreen/>
                            :
                            null
                        }


                        <div ref={`${this.state.screen.screen_id}_bottom_anchor`}/>
                    </div>
                </div>
            </div>
        );
    }
}

VideoMobileScreen.propTypes = {
    screen: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    parentScreen: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    closeDialog: PropTypes.func,
    showContentOutlineInPreview: PropTypes.bool.isRequired,
};

VideoMobileScreen.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData,
        showContentOutlineInPreview: state.showContentOutlineInPreview,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoMobileScreen);



/** WEBPACK FOOTER **
 ** ./src/components/screens/videoScreen/VideoMobileScreen.js
 **/